<template>
<div class="columns" :class="{'is-multiline': isMultiline}" @click="click">
  <slot></slot>
</div>
</template>

<script>
export default {
  props: {
    isMultiline: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/columns.vue